
'use client';

import { useState, type ReactNode } from 'react';
import { Header } from '@/components/header';
import { LeftSidebar } from '@/components/left-sidebar';
import { RightSidebar } from '@/components/right-sidebar';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet';

interface AppLayoutProps {
  children: ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  const [leftSidebarOpen, setLeftSidebarOpen] = useState(false);
  const [rightSidebarOpen, setRightSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-background">
      <Header 
        onLeftSidebarToggle={() => setLeftSidebarOpen(true)}
        onRightSidebarToggle={() => setRightSidebarOpen(true)}
      />
      {/* Mobile Left Sidebar Sheet */}
      <Sheet open={leftSidebarOpen} onOpenChange={setLeftSidebarOpen}>
        <SheetContent side="left" className="p-0 w-[300px]">
          <SheetHeader>
            <SheetTitle className="sr-only">Main Navigation</SheetTitle>
          </SheetHeader>
          <LeftSidebar />
        </SheetContent>
      </Sheet>

      {/* Mobile Right Sidebar Sheet */}
      <Sheet open={rightSidebarOpen} onOpenChange={setRightSidebarOpen}>
        <SheetContent side="right" className="p-0 w-[300px]">
          <SheetHeader>
            <SheetTitle className="sr-only">Friends and Contacts</SheetTitle>
          </SheetHeader>
          <RightSidebar />
        </SheetContent>
      </Sheet>

      <div className="pt-14">{children}</div>
    </div>
  );
}
